import { Navigate, Outlet } from "react-router";
import { usePermission, type PermissionScope } from "../hooks/usePermission.ts";

interface PermissionOutletProps {
  permission: string;
  fallbackPath?: string;
  /** How far the grant must reach — see `usePermission`. Routes that render an
   *  organization-level screen should pass `"organization"`, or they admit a
   *  division administrator to a page whose every request the server refuses. */
  scope?: PermissionScope;
}

export default function PermissionOutlet({ permission, fallbackPath = "/", scope = "context" }: PermissionOutletProps) {
  if (!usePermission(permission, scope)) {
    return <Navigate to={fallbackPath} replace={true} />
  }

  return <Outlet />;
}
